import { EquipmentItemData, INSTRUMENT_CATEGORY } from "@/types/equipmentTypes";
import { NullObjectCustomField, ObjectCustomField } from "./customFields/objectCustomField";

export class EquipmentItem {
  static readonly MODEL_TYPE = 'equipmentitem';

  id: string;
  name: string;
  description: string;
  identifier: string;
  procedureInstanceId: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  defaultConfiguration: ObjectCustomField;
  category: INSTRUMENT_CATEGORY;

  constructor(params: EquipmentItemData) {
    this.id = params.id;
    this.identifier = params.identifier;
    this.procedureInstanceId = params.procedureInstanceId;
    this.name = params.name;
    this.description = params.description;
    this.defaultConfiguration = params.defaultConfiguration ? new ObjectCustomField(params.defaultConfiguration) : new NullObjectCustomField();
    this.category = params.category || INSTRUMENT_CATEGORY.NONE;
  }
}
